import { createContext, useContext } from "react";

export interface LiffProfile {
  userId: string;
  displayName: string;
  pictureUrl?: string;
  statusMessage?: string;
}

export type LiffStatus = "loading" | "ready" | "error" | "unavailable";

export interface LiffContextValue {
  status: LiffStatus;
  /** Running inside the real LINE app (vs external browser). */
  isInClient: boolean;
  isLoggedIn: boolean;
  profile: LiffProfile | null;
  error: string | null;
  /** Whether mock mode is active (local dev). */
  isMock: boolean;
  /** Trigger LINE login (no-op in mock mode). */
  login: () => void;
}

export const LiffContext = createContext<LiffContextValue | null>(null);

export function useLiff(): LiffContextValue {
  const ctx = useContext(LiffContext);
  if (!ctx) {
    throw new Error("useLiff must be used within <LiffProvider>");
  }
  return ctx;
}
